export const APP_API_URL = process.env.REACT_APP_API_URL;
export const APP_VERSION = process.env.REACT_APP_VERSION || "";
export const APP_PUBLIC_URL = process.env.PUBLIC_URL || "";
export const IS_PRODUCTION = process.env.NODE_ENV !== "production";
export const API_URL = APP_API_URL+"user/api/v1/";
export const FILE_API_URL = APP_API_URL + "file/api/v1/";
export const TICKET_API_URL = APP_API_URL + "ticket/api/v1/";

